import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { replacePiiDeleted } from '../../../assets/utils/replacePiiDeleted';
import { RootState } from '../../../utils/store';

import { PiiRemovalMessageBoxProps } from '~/services/api/reports/types';

const PiiRemovalMessageBox = ({
  messageContent,
  messageId,
}: PiiRemovalMessageBoxProps) => {
  const piiRemovedMessageRanges = useSelector(
    (state: RootState) => state.piiRemoval.piiRemovedMessageRanges,
  );


  

  const [highlightedText, setHighlightedText] = useState<string>('');

  const applyHighlight = useCallback(() => {
    let removedText = '';
    let lastIndex = 0;
    // Find the specific message by messageId
    const messageRange = piiRemovedMessageRanges?.find(
      (range) => range.messageId === messageId,
    );

    if (!piiRemovedMessageRanges) {
      return messageContent;
    } else {
      const positions = [...(messageRange?.contentPiiRemovedRanges || [])];

      positions.sort((a, b) => a[0] - b[0]);
      positions.forEach((range) => {
        if (!range) return;
        const [start, end] = range;
        removedText += messageContent.substring(lastIndex, start);
        removedText += `<span style="background-color: red">${messageContent.substring(
          start,
          end,
        )}</span>`;
        lastIndex = end;
      });

      removedText += messageContent.substring(lastIndex);

      const replacedText = replacePiiDeleted(removedText);
      return replacedText;
    }
  }, [piiRemovedMessageRanges]); //eslint-disable-line

  useEffect(() => {
    setHighlightedText(applyHighlight());
  }, [piiRemovedMessageRanges, applyHighlight]);


  return (
    <div>
      <div
        contentEditable={false}
        className='pl-2 rounded mb-2 mt-2 formatted-text-viewer'
        dangerouslySetInnerHTML={{ __html: highlightedText }}
      />
      <style>
        {`
        .highlight {
          background-color: red;
          color: black;
        }
      `}
      </style>
    </div>
  );
};

export default PiiRemovalMessageBox;
